import React from 'react';
import { CtaButton } from './CtaButton';
import { YouAreHereDot } from './Section';
import { heroBadges, offer, trustItems } from '../data/offer';
export function Hero() {
  return <header className="w-full bg-creme" data-id="element-127" data-mp="9kjxsrx55a59">
      <div className="mx-auto w-full max-w-6xl px-6 pb-16 pt-5 md:px-10 md:pb-24 md:pt-14" data-id="element-128" data-mp="9llat1xpw6pm">
        <div className="flex items-center gap-3 border-b border-warm-line pb-4 md:pb-6" data-id="element-129" data-mp="4mrxb9ifkfpg">
          <YouAreHereDot data-id="element-130" data-mp="129qs1epkbdkp" />
          <p className="text-xs font-semibold uppercase tracking-[0.16em] text-graphite" data-id="element-131" data-mp="128yzydv6bxz6">
            {offer.name} — {offer.method}
          </p>
        </div>

        <div className="grid grid-cols-1 gap-10 pt-7 md:gap-14 md:pt-14 lg:grid-cols-12 lg:gap-16" data-id="element-132" data-mp="sarsqmqosuad">
          <div className="flex flex-col lg:col-span-7" data-id="element-133" data-mp="nczsn5fw21v3">
            <p className="order-1 max-w-prose font-serif text-base italic leading-snug text-warm md:text-xl md:leading-relaxed" data-id="element-134" data-mp="neaz5d0pxnpw">
              La plupart des accompagnements ne s’arrêtent pas faute de clients.
              Ils s’arrêtent à la quatrième séance.
            </p>

            <h1 className="order-2 mt-4 font-serif text-[1.85rem] font-semibold leading-[1.1] tracking-[-0.015em] text-graphite md:mt-6 md:text-[3.6rem] md:leading-[1.08]" data-id="element-135" data-mp="3j9283w7ie4z8">
              Menez chaque accompagnement jusqu’à la dernière séance, avec le
              cadre d’un coach professionnel.
              <span className="block text-warm" data-id="element-136" data-mp="3e7ux7oa2kpoc">
                Même avec vos premiers clients.
              </span>
            </h1>

            <div className="order-3 mt-6 md:order-5 md:mt-10" data-id="element-137" data-mp="358rbsdnfjy6o">
              <CtaButton className="w-full sm:w-auto" data-id="element-138" data-mp="35aax4iny0zfb">
                Accéder au Système Complet du Coach
              </CtaButton>
              <ul className="mt-4 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-warm md:mt-5" data-id="element-139" data-mp="2viy2jjarfv5l">
                {trustItems.map((item, index) => <li key={item} className="flex items-center gap-3" data-id="element-140" data-mp="2hjoz7k7nkvj1" data-mpi={index}>
                    <span data-id="element-141" data-mp="2ll0gn2gdiag5">{item}</span>
                    {index < trustItems.length - 1 && <span aria-hidden="true" className="text-warm-line" data-id="element-142" data-mp="s2b8o0ipgn67">
                        ·
                      </span>}
                  </li>)}
              </ul>
            </div>

            <p className="order-4 mt-8 max-w-prose text-base leading-relaxed text-graphite-mid md:order-3 md:text-lg" data-id="element-143" data-mp="icrp0sn64paa">
              Le système complet en 6 tomes pour les coachs qui accompagnent des
              particuliers : 23 fiches imprimables, des trames de séance, une
              feuille de route co-construite et le Point d’Ancrage. De la Séance
              Zéro au cap de la quatrième séance, jusqu’au bilan de clôture.
            </p>

            <ul className="order-5 mt-6 flex flex-wrap gap-x-3 gap-y-2 md:order-4 md:mt-8" data-id="element-144" data-mp="x1edpkyoqte6">
              {heroBadges.map(badge => <li key={badge} className="rounded-sm border border-warm-line bg-white px-3 py-1.5 text-xs font-medium text-graphite-mid" data-id="element-145" data-mp="3ltqbtahzursg">
                  {badge}
                </li>)}
            </ul>
          </div>

          <div className="lg:col-span-5" data-id="element-146" data-mp="21by0zcwfr6f1">
            <figure className="lg:sticky lg:top-10" data-id="element-147" data-mp="218tqjxsdnefx">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/3e5a6efc-2090-4ece-93e1-f2ec3e03904d.jpg" alt="Les six tomes du Système Complet du Coach et une feuille de route de parcours en trois phases" className="w-full border border-warm-line bg-white object-cover shadow-paper" width={1200} height={900} data-id="element-148" data-mp="268y71ntac965" />
              <figcaption className="mt-4 flex items-start gap-2 text-xs leading-relaxed text-warm" data-id="element-149" data-mp="2p10dk6c7q92o">
                <YouAreHereDot className="mt-1.5" data-id="element-150" data-mp="2tz1zcz10wmhu" />
                <span data-id="element-151" data-mp="umzhft81s06a">
                  La feuille de route et son point rouge : « Vous êtes ici ».
                  C’est ce repère qui manque à la quatrième séance.
                </span>
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </header>;
}